
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import { MunicipalityResponse } from "../../models/dtos";

export const municipalitiesApi = createApi({
  reducerPath: 'municipalitiesApi',
  baseQuery: baseAuthQuery('Municipalities'),
  tagTypes: ['Municipality'],
  endpoints: (builder) => ({
    getMunicipalities: builder.query<ApiResponse<MunicipalityResponse[]>, void>({
      query: () => "",
      providesTags: ['Municipality'],
    }),
    getMunicipalityById: builder.query<ApiResponse<MunicipalityResponse>, number>({
      query: (id) => ({ url: `/${id}` }),
      providesTags: ['Municipality'],
    }),
    updateMunicipality: builder.mutation<ApiResponse<MunicipalityResponse>, Partial<MunicipalityResponse>>({
      query: (body) => ({ url: "CreateOrUpdate", method: "POST", body }),
      invalidatesTags: ['Municipality'],
    }),
    deleteMunicipality: builder.mutation<ApiResponse<boolean>, number>({
      query: (id) => ({ url: `Delete/${id}`, method: "GET" }),
      invalidatesTags: ['Municipality'],
    }),
  }),
});
